module.exports = __webpack_public_path__ + "static/img/2_1.5896296.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/2_1.png
// module id = ieXl
// module chunks = 1